import { render, staticRenderFns } from "./FlexiFundWithdraw.vue?vue&type=template&id=b5f6d7f6&scoped=true&"
import script from "./FlexiFundWithdraw.vue?vue&type=script&lang=js&"
export * from "./FlexiFundWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./FlexiFundWithdraw.vue?vue&type=style&index=0&id=b5f6d7f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f6d7f6",
  null
  
)

export default component.exports